export const NAME = 'customerSubmission';
